import { useVerifier, VerifyInput, VerifyResult } from "@/components/PermitVerifier";
import { PageHeader } from "@/components/common";

export default function VerifyOnly() {
  const v = useVerifier();
  return (
    <div className="max-w-3xl mx-auto space-y-5">
      <PageHeader title="التحقق من تصريح الخروج" subtitle="عرض حالة التصريح فقط" />
      <VerifyInput v={v} />
      <VerifyResult res={v.res} />
    </div>
  );
}
